import { type Jast, JastBuilder } from '@atlaskit/jql-ast';
import type { SortOrder } from './types.tsx';
import { getOrderBy } from './utils/get-order-by.tsx';
import { getPrimarySortDirection } from './utils/get-primary-sort-direction.tsx';
import { getPrimarySortField } from './utils/get-primary-sort-field.tsx';
import { setPrimarySortDirection } from './utils/set-primary-sort-direction.tsx';
import { setPrimarySortField } from './utils/set-primary-sort-field.tsx';

export class JqlUtils {
	jast: Jast | undefined = undefined;

	jqlString: string | undefined = undefined;

	jql(newJqlString: string): this {
		const newJast = new JastBuilder().build(newJqlString);
		if (newJast.errors.length && this.jast) {
			return this;
		}
		this.jast = newJast;
		this.jqlString = newJqlString;
		return this;
	}

	ast(ast: Jast): this {
		this.jast = ast;
		this.jqlString = ast.represents;
		return this;
	}

	setPrimarySortField(
		sortField: string,
		sortDirection: string | undefined,
		aliases: string[],
	): this {
		if (!this.jast) {
			return this;
		}

		return this.jql(setPrimarySortField(this.jast, sortField, sortDirection, aliases));
	}

	setPrimarySortDirection(sortOrder: SortOrder): this {
		if (!this.jast) {
			return this;
		}
		return this.jql(setPrimarySortDirection(sortOrder, this.jast));
	}

	getPrimarySortField(): string | undefined {
		if (!this.jast) {
			return undefined;
		}
		return getPrimarySortField(this.jast);
	}

	getPrimarySortDirection(): SortOrder | undefined {
		if (!this.jast) {
			return undefined;
		}
		return getPrimarySortDirection(this.jast);
	}

	getOrderBy(): string | undefined {
		if (!this.jast) {
			return undefined;
		}
		return getOrderBy(this.jast);
	}

	toJql(): string | undefined {
		return this.jqlString;
	}
}
